import { render, staticRenderFns } from "./SendgridMailForm.vue?vue&type=template&id=40130a89"
import script from "./SendgridMailForm.vue?vue&type=script&lang=js"
export * from "./SendgridMailForm.vue?vue&type=script&lang=js"
import style0 from "./SendgridMailForm.vue?vue&type=style&index=0&id=40130a89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports